import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hidden",
  "use": "hidden-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 192\" id=\"hidden\"><title>icons</title><path d=\"M96,60a36,36,0,0,1,33.22,49.9l16.64,16.64A80.21,80.21,0,0,0,169.32,96,80,80,0,0,0,71.24,51.92L82.1,62.78A35.92,35.92,0,0,1,96,60Z\" /><path d=\"M91.71,72.39l27.9,27.9a24,24,0,0,0-27.9-27.9Z\" /><path d=\"M37.66,34.34A8,8,0,0,0,26.34,45.66L46.15,65.47A80.11,80.11,0,0,0,22.68,96a80,80,0,0,0,98.08,44.08l25.58,25.58a8,8,0,0,0,11.32-11.32ZM96,132A36,36,0,0,1,62.79,82.11l9.6,9.59A23.47,23.47,0,0,0,72,96a24,24,0,0,0,24,24,23.47,23.47,0,0,0,4.3-.39l9.59,9.6A35.84,35.84,0,0,1,96,132Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/hidden.svg
// module id = 1862
// module chunks = 0